import "./App.css";
import { ToastProvider } from "./components/Toast/ToastContext";
import "./color-constants.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./Core/Components/ProtectedRoute/ProtectedRoute";
import { useEffect } from "react";
import serviceWorkerRegistration from "./serviceWorkerRegistration";
import LandingPage from "./Core/Components/LandingPage/LandingPage";
import Auth from "./Core/Components/Auth/Auth";
import Home from "./Core/Components/LandingPage/Home/Home";
import About from "./Core/Components/LandingPage/About/About";
import Team from "./Core/Components/LandingPage/Team/Team";
import MainWrapper from "./Core/Components/MainWrapper/MainWrapper";
import { NavigationBlockerProvider } from "./components/NavigationBlocker/NavigationBlocker";
import RootRedirect from "./Core/Components/RootRedirect/RootRedirect";
import PublicInfo from "./Core/Components/PublicInfo/PublicInfo";

function App() {
  // Service worker registration
  useEffect(() => {
    const onUpdate = (registration) => {
      if (window.confirm("New version available! Would you like to update?")) {
        const worker = registration.waiting;
        if (worker) {
          worker.postMessage({ action: "skipWaiting" });
          const stateChangeHandler = (event) => {
            if (event.target.state === "activated") {
              window.location.reload(true);
            }
          };
          worker.addEventListener("statechange", stateChangeHandler);
          return () => worker.removeEventListener("statechange", stateChangeHandler);
        }
      }
    };

    const registration = serviceWorkerRegistration({ onUpdate });
    return () => {
      if (registration && registration.unregister) {
        registration.unregister();
      }
    };
  }, []);

  return (
    <div translate="no" className="h-screen w-screen overflow-hidden">
      {/* Skip link for keyboard users */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 bg-black text-white px-3 py-2 rounded"
      >
        Skip to main content
      </a>
      {/* Route change live region announcer for screen readers */}
      <div id="route-change-region" aria-live="polite" aria-atomic="true" className="sr-only" />
      <ToastProvider>
        <Router>
          <NavigationBlockerProvider>
            <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />}>
              <Route index element={<RootRedirect />} />
              <Route path="home" element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="team" element={<Team />} />
            </Route>
            <Route path="/view" element={<PublicInfo />} />
            <Route path="/view/:privateKey" element={<PublicInfo />} />
            <Route path="/auth" element={<Auth />} />

            {/* Admin routes */}
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute requiredRole="admin">
                  <MainWrapper userType="admin" />
                </ProtectedRoute>
              }
            />

            {/* User routes */}
            <Route
              path="/user/*"
              element={
                <ProtectedRoute requiredRole="user">
                  <MainWrapper userType="user" />
                </ProtectedRoute>
              }
            />
          </Routes>
          </NavigationBlockerProvider>
        </Router>
      </ToastProvider>
    </div>
  );
}

export default App;
